import React from 'react';
import { toast as sonnerToast } from 'sonner';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
import CloseIcon from '@mui/icons-material/Close';
import { alpha } from '@mui/system';

export type ToastSeverity = 'success' | 'error' | 'info' | 'warning' | 'loading';

export const renderMuiToast = (id: string | number, message: string, severity: ToastSeverity) => (
  <Alert
    severity={severity === 'loading' ? 'info' : severity}
    icon={
      severity === 'loading' ? (
        <CircularProgress size={20} sx={{ color: 'primary.contrastText' }} />
      ) : undefined
    }
    elevation={3}
    sx={{
      width: '100%',
      alignItems: 'center',
      backgroundColor: (theme) => alpha(theme.palette.primary.dark, 0.98),
      color: 'primary.contrastText',
      borderRadius: '8px',
    }}
    action={
      <IconButton size="small" color="inherit" onClick={() => sonnerToast.dismiss(id)}>
        <CloseIcon fontSize="small" />
      </IconButton>
    }
  >
    {message}
  </Alert>
);
